import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/pageContext';

export const HEADING_DEFAULTS = {
	data: { title: '', description: '', image: { alt: '', url: '' } },
};

type Result = ModelHookResult<{
	ctaSection: {
		title: string;
		ctaText: string;
		image: {
			alt: string;
			src: string;
		};
	};
}>;

export function useCTASection(): Result {
	const {
		data: {
			ctaSection: { heading, primaryActionText, image },
		},
	} = usePetitionGuidesPageData();

	return {
		data: {
			ctaSection: {
				title: heading,
				ctaText: primaryActionText,
				image: {
					alt: image.title,
					src: image.url,
				},
			},
		},
	};
}
